export default __webpack_public_path__ + "static/media/aroundTheWorld.174b0ee2.mp4";